import { useFormContext, UseFormReturn } from "react-hook-form";
import { AddPatientFormFieldValues } from "../AddPatient";

export function useAddPatientFormContext(): UseFormReturn<AddPatientFormFieldValues, any> {
  return useFormContext<AddPatientFormFieldValues>();
}
